const TOKEN_KEY = 'sms_admin_token'
const API_BASE_URL =
  (typeof window !== 'undefined' && window.__API_BASE_URL__) ||
  process.env.VUE_APP_API_BASE_URL ||
  ''

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
    return
  }
  localStorage.removeItem(TOKEN_KEY)
}

function resolveApiUrl(path) {
  if (/^https?:\/\//i.test(path)) {
    return path
  }
  if (!API_BASE_URL) {
    return path
  }
  return `${API_BASE_URL.replace(/\/$/, '')}${path}`
}

async function parseResponse(res) {
  const data = await res.json().catch(() => ({}))
  if (!res.ok || data.ok === false) {
    const message = data.message || data.error || `请求失败: ${res.status}`
    throw new Error(message)
  }
  return data
}

export async function apiFetch(path, options = {}) {
  const method = String(options.method || 'GET').toUpperCase()
  const hasExplicitContentType = Object.keys(options.headers || {}).some(
    (key) => key.toLowerCase() === 'content-type'
  )
  const isBinaryBody =
    typeof Blob !== 'undefined' && options.body instanceof Blob
  const headers = {
    ...(hasExplicitContentType || isBinaryBody ? {} : { 'Content-Type': 'application/json' }),
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    ...(options.headers || {})
  }
  const token = getToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  let requestUrl = resolveApiUrl(path)
  if (method === 'GET' || method === 'HEAD') {
    const hasQuery = requestUrl.includes('?')
    const separator = hasQuery ? '&' : '?'
    requestUrl = `${requestUrl}${separator}_ts=${Date.now()}`
  }

  const timeoutMs = Number(options.timeoutMs || 0)
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
  let timeoutId = null
  if (controller && timeoutMs > 0) {
    timeoutId = setTimeout(() => controller.abort(new Error('REQUEST_TIMEOUT')), timeoutMs)
  }

  try {
    const res = await fetch(requestUrl, {
      cache: 'no-store',
      ...options,
      headers,
      signal: controller ? controller.signal : options.signal
    })
    return await parseResponse(res)
  } catch (error) {
    if (error?.name === 'AbortError') {
      throw new Error(timeoutMs > 0 ? `请求超时，请在网络稳定后重试（超过 ${Math.ceil(timeoutMs / 1000)} 秒）` : '请求已取消')
    }
    throw error
  } finally {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
  }
}
